export const browserTest = {
    showWarningModal: false,
};
